import Sequence from '@/models/Sequence';
import Channel from '@/models/Channel';
import Search from '@/models/Search';

const general = new Channel({
  name: 'à La Une',
  search: new Search({
    topics: [
      'La Une',
    ],
  }),
});

const player = {
  state: {
    loading: false,
    isChanging: false,
    isPlaying: false,
    isDetail: false,
    currentChannelId: general.id,
    currentSequenceId: '',
    displayedSequence: undefined,
    currentSlug: '',
    channels: [
      general,
      /* new Channel({
        name: 'dernière minute',
        search: new Search({
          topics: [
            'dernière minute',
          ],
        }),
      }),
      new Channel({
        name: 'insolite',
        search: new Search({
          topics: [
            'insolite',
          ],
        }),
      }), */
      // TODO : update recherche channel
      /* new Channel({
        name: 'Recherche',
        type: Channel.TYPES.tempory,
      }), */
    ],
    sequences: [],
  },
  getters: {
    loading: state => state.loading,
    isPlaying: state => state.isPlaying,
    isChangeSequence: state => state.isChanging
      || state.loading
      || !state.isPlaying
      || !state.displayedSequence,
    isDetail: state => state.isDetail,
    channels: state => state.channels,
    sequences: state => state.sequences,
    general: state => state.channels.find(s => s.id === general.id),
    // eslint-disable-next-line
    currentChannel: state => state.channels.find(s => s.id === state.currentChannelId) || new Channel(),
    // eslint-disable-next-line
    currentSequence: state => state.sequences.find(s => s.id === state.currentSequenceId),
    // eslint-disable-next-line
    displayedSequence: state => state.displayedSequence,
    displayedName: state => state.currentSlug || general.name,
    currentSlug: state => state.currentSlug,
    nextChannel(state, getters) {
      const index = state.channels.indexOf(getters.currentChannel);
      return state.channels[index < getters.channels.length - 1 ? index + 1 : 0];
    },
    previousChannel(state, getters) {
      const index = state.channels.indexOf(getters.currentChannel);
      return state.channels[index > 0 ? index - 1 : getters.channels.length - 1];
    },
    nextSequence(state, getters) {
      const index = state.sequences.indexOf(getters.currentSequence);
      return state.sequences[index < getters.sequences.length - 1 ? index + 1 : 0];
    },
    previousSequence(state, getters) {
      const index = state.sequences.indexOf(getters.currentSequence);
      return state.sequences[index > 0 ? index - 1 : getters.sequences.length - 1];
    },
    sequenceColors(state) {
      return state.displayedSequence ? state.displayedSequence.colors : Sequence.colors[0];
    },
    startColor(state, getters) {
      return `rgba(${getters.sequenceColors.start[0]}, ${getters.sequenceColors.start[1]}, ${getters.sequenceColors.start[2]},1)`;
    },
    endColor(state, getters) {
      return `rgba(${getters.sequenceColors.end[0]}, ${getters.sequenceColors.end[1]}, ${getters.sequenceColors.end[2]}, 0.8)`;
    },
  },
  mutations: {
    setChanging(state, isChanging) {
      state.isChanging = !!isChanging;
    },
    startLoading(state) {
      state.loading = true;
    },
    stopLoading(state) {
      state.loading = false;
    },
    play(state) {
      state.isPlaying = true;
    },
    pause(state) {
      state.isPlaying = false;
    },
    openDetail(state) {
      state.isDetail = true;
    },
    closeDetail(state) {
      state.isDetail = false;
    },
    addChannel(state, channel = {}) {
      if (channel instanceof Channel) {
        state.channels = {
          ...state.channels,
          [channel.id]: channel,
        };
      }
    },
    removeChannel(state, channel) {
      if (channel instanceof Channel) {
        state.channels = state.channels.filter(c => c.id !== channel.id);
      }
    },
    updateChannel(state, channel = {}) {
      if (channel instanceof Channel) {
        const current = state.channels.indexOf(state.channels.find(c => c.id === channel.id));
        // eslint-disable-next-line
        const tempory = state.channels.indexOf(state.channels.find(c => c.type === Channel.TYPES.tempory));

        if (current >= 0) {
          state.channels[current] = channel;
        } else if (tempory >= 0) {
          state.channels[tempory] = channel;
        } else {
          state.channels.push(channel);
        }
      }
    },
    setChannelName(state, { channel, name }) {
      if (channel instanceof Channel) {
        channel.setName(name);
      }
    },
    setCurrentChannel(state, newCurrentChannel) {
      if (newCurrentChannel instanceof Channel) {
        state.sequences = newCurrentChannel.sequences;
        state.currentSequenceId = newCurrentChannel.currentSequenceId;
        state.currentChannelId = newCurrentChannel.id;
      }
    },
    setCurrentSequence(state, newCurrentSequence) {
      if (newCurrentSequence instanceof Sequence) {
        state.currentSequenceId = newCurrentSequence.id;
      }
    },
    setDisplayedSequence(state, newDisplayedSequence) {
      if (newDisplayedSequence instanceof Sequence) {
        state.displayedSequence = newDisplayedSequence;
      }
    },
    setCurrentIndex(state, newIndex) {
      state.index = newIndex;
    },
    setCurrentSlug(state, newCurrentSlug) {
      state.currentSlug = newCurrentSlug;
    },
  },
  actions: {
    playSequence({ commit, getters }, sequence) {
      commit('setCurrentSequence', sequence);
      commit('updateChannel', new Channel({
        ...getters.currentChannel,
        currentSequenceId: sequence.id,
      }));
      getters.nextSequence.getMedia().preloadImage();
    },
    playNextSequence({ dispatch, getters }) {
      dispatch('playSequence', getters.nextSequence);
    },
    playPreviousSequence({ dispatch, getters }) {
      dispatch('playSequence', getters.previousSequence);
    },
    playChannel({ commit, getters }, channel) {
      commit('updateChannel', channel);
      commit('setCurrentChannel', channel);

      [getters.nextSequence, getters.currentSequence, getters.previousSequence]
        .filter(s => s instanceof Sequence)
        .forEach(s => s.getMedia().preloadImage());
    },
    updateSlug({ commit, getters }, slug) {
      const uno = getters.currentSequence ? getters.currentSequence.uno : '';
      const channel = new Channel({
        name: slug,
        type: Channel.TYPES.tempory,
        search: new Search({
          slugs: [slug],
          uno,
        }),
      });

      if (slug) {
        commit('updateChannel', channel);
      }

      commit('setCurrentSlug', channel.id);
    },
    getChannelById({ state }, channelId) {
      return state.channels.find(c => c.id === channelId);
    },
  },
};

export default player;



// WEBPACK FOOTER //
// ./src/store/modules/Player.js